import { useEffect, useRef, useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import { MdClose } from "react-icons/md";
import {
    FaRegCalendar,
} from "react-icons/fa";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
} from "../Styles/InputStyles";
import { toast } from "react-toastify";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import DropZone from "../Notice/Dropzone";
import { capitalizeFirstLetter, paymentModes } from "../../helpers";

const MarkAsPaidModal = ({
    setIsMarkAsPaidAllDue,
    markAsPaidAllDueMutate,
    markAsPaidAllDueLoading,
    selectedData,
    isEvicted,
    data
}) => {
    const bankAccount = data?.data?.bankAccounts
    const [calendarOpen, setCalendarOpen] = useState(false);
    const formikRef = useRef(null);
    const today = moment().format("YYYY-MM-DD");

    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight); // updates when Safari UI changes
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Ensure bankAccount is always an array
    const bankAccounts = Array.isArray(bankAccount) ? bankAccount : [];

    const initialValues = {
        tenantid: data?.data?.id,
        collectionDate: "",
        paymentMode: "",
        transactionId: "",
        bankAccount: "",
        paymentAccountNo: "",
        paymentAccountName: "",
        file: null,
        remarks: "",
    };

    const handleSubmit = (values, formikHelpers) => {
        if (!values.collectionDate) {
            toast.error("Date is required");
            return;
        }

        if (
            values.paymentMode === undefined ||
            values.paymentMode === null ||
            !values.paymentMode
        ) {
            toast.error("Payment mode is required");
            return;
        }
        let newTime = values.collectionDate + " " + moment().format("HH:mm:ss");


        const selectedBankAccount = [2, 3, 4].includes(values.paymentMode)
            ? bankAccounts.find(acc => acc.id.toString() === values.bankAccount)
            : null;


        const formData = new FormData()
        formData.append("collectionDate", moment(newTime).utc().format())
        formData.append("transactionId", values.transactionId)
        formData.append("mode", values.paymentMode)
        formData.append("tenantId", data?.data?.id)
        formData.append("isEvicted", isEvicted)
        formData.append("paymentAccountNo", selectedBankAccount?.accountNum || "",)
        formData.append("paymentAccountName", selectedBankAccount?.holderName || "");
        formData.append("remarks", values.remarks || "");
        if (values.file) {
            formData.append("file", values.file[0])
        }
        markAsPaidAllDueMutate(formData)
    };

    const handleClose = () => {
        setIsMarkAsPaidAllDue(false);
    };

    const handleBankAccountChange = (event, setFieldValue) => {
        const selectedId = event.target.value;
        setFieldValue("bankAccount", selectedId);

        const selectedAccount = bankAccounts.find(acc => acc.id.toString() === selectedId);
        if (selectedAccount) {
            setFieldValue("paymentAccountNo", selectedAccount.accountNum);
            setFieldValue("paymentAccountName", selectedAccount.holderName);
        }
    };

    const clearBankAccountFields = (setFieldValue) => {
        setFieldValue("bankAccount", "");
        setFieldValue("paymentAccountNo", "");
        setFieldValue("paymentAccountName", "");
    };

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <Header>
                <h1 className="text-white text-lg font-medium">Settle All Dues</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>
            <ProfileSection className="flex justify-between">
                <UserInfo>
                    <span className="font-medium mb-0">
                        {capitalizeFirstLetter(data?.data?.name)}
                    </span>
                    <span className="text-sm text-gray-600">
                        {'#' + data?.data?.occupancy?.roomNum + ", " + data?.data?.occupancy?.flatName + ", " + data?.data?.occupancy?.propName}
                    </span>
                </UserInfo>
                <div className="flex flex-col gap-0">
                    <span className='text-gray-500 text-sm'>{'Total Dues'}</span>
                    <span className='text-xl font-semibold text-gray-700'>{'₹' + data?.data?.totalDues}</span>
                </div>
            </ProfileSection>
            <div className="px-4 flex flex-col justify-between" >
                <Formik innerRef={formikRef} initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
                    {({ setFieldValue, values, resetForm }) => (
                        <Form>
                            <ScrollableContent className="!max-h-[calc(100dvh-180px)]">
                                <Wrapper>
                                    <InputGroup>
                                        <Label htmlFor="collectionDate">Collection Date *</Label>
                                        <FieldWrappers className="relative w-full">
                                            <DatePicker
                                                selected={values.collectionDate ? new Date(values.collectionDate) : null}
                                                onChange={(date) =>
                                                    setFieldValue("collectionDate", moment(date).format("YYYY-MM-DD"))
                                                }
                                                maxDate={new Date()}
                                                dateFormat="yyyy-MM-dd"
                                                className="  cursor-pointer"
                                                placeholderText="YYYY-MM-DD"
                                                onClickOutside={() => setCalendarOpen(false)}
                                                onSelect={() => setCalendarOpen(false)}
                                                open={calendarOpen}
                                                onInputClick={() => setCalendarOpen(true)}
                                                popperPlacement="top-end"
                                                showIcon
                                                icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                                                showPopperArrow={false}
                                                onFocus={(e) => e.target.blur()}
                                                wrapperClassName="w-full"
                                                portalId="root-portal"
                                                popperClassName="react-datepicker-popper"
                                            />
                                        </FieldWrappers>
                                    </InputGroup>

                                    <InputGroup>
                                        <Label>Payment Mode *</Label>
                                        <PaymentModeWrapper>
                                            {paymentModes.map((mode) => (
                                                <PaymentModeCard
                                                    key={mode.value}
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setFieldValue("paymentMode", mode.value, false);
                                                        clearBankAccountFields(setFieldValue);
                                                    }}
                                                    className={
                                                        values.paymentMode === mode.value
                                                            ? "bg-blue-100 border-blue-500"
                                                            : "bg-gray-100"
                                                    }
                                                >
                                                    <span className="text-sm">{mode.label}</span>
                                                </PaymentModeCard>
                                            ))}
                                        </PaymentModeWrapper>
                                    </InputGroup>

                                    {/* Only show bank account dropdown if there are bank accounts */}
                                    {bankAccounts.length > 0 && [2, 3, 4].includes(values.paymentMode) && (
                                        <InputGroup>
                                            <Label htmlFor="bankAccount">Bank Account </Label>
                                            <Select
                                                id="bankAccount"
                                                name="bankAccount"
                                                value={values.bankAccount || ''}
                                                onChange={(e) => handleBankAccountChange(e, setFieldValue)}
                                                displayEmpty
                                                fullWidth
                                                className="px-2"
                                                style={{ height: "46px" }}
                                            >
                                                <MenuItem value="">
                                                    <em>Select Bank Account</em>
                                                </MenuItem>
                                                {bankAccounts.map((account) => (
                                                    <MenuItem key={account.id} value={account.id.toString()}>
                                                        {account.accountNum} - {account.holderName}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </InputGroup>
                                    )}


                                    <InputGroup>
                                        <Label htmlFor="transactionId">Transaction ID</Label>
                                        <FieldWrappers>
                                            <Field
                                                type="text"
                                                name="transactionId"
                                                id="transactionId"
                                                autoComplete="off"
                                            />
                                        </FieldWrappers>
                                    </InputGroup>
                                    <InputGroup>
                                        <Label htmlFor="remarks">Remarks</Label>
                                        <FieldWrapper>
                                            <Field
                                                as={Textarea}
                                                id="remarks"
                                                name="remarks"
                                                rows={4}
                                                maxLength={500}
                                                placeholder="Write your remark here..."
                                            />
                                        </FieldWrapper>
                                    </InputGroup>
                                    <InputGroup>
                                        <Label htmlFor="file">Document(optional)</Label>
                                        <FieldWrapper $select={true}>
                                            <Field
                                                required
                                                name="file"
                                                type="text"
                                                id="file"
                                                autoComplete="off"
                                            >
                                                {(props) => (
                                                    <DropZone
                                                        fields={props.field}
                                                        setFieldValue={props.form.setFieldValue}
                                                        componentFor="expense"
                                                        acceptedFiles="image/*,application/pdf"
                                                        File={props.field.value ? [props.field.value] : null}
                                                    />
                                                )}
                                            </Field>
                                        </FieldWrapper>
                                    </InputGroup>

                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={() => {
                                    resetForm();
                                    handleClose();
                                }}>
                                    Cancel
                                </SideCancelBtn>
                                <SubmitBtn type="submit" disabled={markAsPaidAllDueLoading}>
                                    {markAsPaidAllDueLoading ? "Submiting..." : "Submit"}
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    );
};

const PaymentModeWrapper = tw.div`grid grid-cols-4 gap-2 my-1.5`;
const PaymentModeCard = tw.button`flex flex-col items-center justify-center p-2 border rounded-lg shadow-sm cursor-pointer`;
const Container = tw.div`bg-white w-full h-full flex flex-col relative `;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const FieldWrapper = tw.div`w-full`
const OptionCard = tw.div`
  flex flex-col items-center justify-center p-3 rounded-lg shadow border border-gray-200 text-center
  cursor-pointer transition-all duration-200 
  ${(props) =>
        props.isselected === "true"
            ? "bg-blue-50 border-blue-500"
            : "bg-white hover:bg-gray-50"}
`;
const Textarea = tw.textarea`min-h-30 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-30 resize-y  break-words overflow-hidden`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
export default MarkAsPaidModal;